import React, { Component } from 'react';
import styles from './Divider.scss';

export default class Divider extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    const { childern } = this.props;
    return (
      <li className={styles['divider']}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Divider/Divider.js